import { RootReducer } from 'types/redux'

export const payschedulesSelector = (state: RootReducer): { cut_off_date: string } => ({
  cut_off_date: state.payschedule.cut_off_date,
})

export const fetchingSelector = (state: RootReducer): boolean => state.payschedule.fetching
export const loadingSelector = (state: RootReducer): boolean => state.payschedule.loading
